/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-04-14",
    versionChannel: "nightly",
    buildDate: "2023-04-14T00:21:02.903Z",
    commitHash: "decfb19aaebb2cf83f1499912be920c8ae470cef",
};
